
const switchRequest = () => {
  return window.ethereum.request({
    method: 'wallet_switchEthereumChain',
    params: [{chainId: process.env.REACT_APP_DEFAULT_CHAINID_HEX}],
  })
}

export const switchNetwork = async () => {
  if (window.ethereum) {
    try {
      await switchRequest()
    } catch (error: any) {
      if (error.code === 4902) {
        try {
          await switchRequest()
        } catch (addError) {
          console.log(error)
        }
      }
      console.log(error)
    }
  }
}
